import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import wsService from '../services/WebSocketService';

const styles = {
  sidebar: (isOpen) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    width: 'min(82vw, 250px)',
    background: '#fff',
    borderRight: '1px solid #E8EBF2',
    zIndex: 101,
    transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
    transition: 'transform 0.25s ease',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  }),
  header: {
    padding: '14px 16px',
    borderBottom: '1px solid #F1F4F9',
    fontSize: '14px',
    fontWeight: '700',
    color: '#1F2937',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeBtn: {
    background: 'none',
    border: 'none',
    color: '#6B7280',
    cursor: 'pointer',
    fontSize: '18px',
    lineHeight: 1,
    padding: '0 2px',
  },
  list: {
    flex: 1,
    overflowY: 'auto',
  },
  item: (isActive) => ({
    padding: '10px 16px',
    cursor: 'pointer',
    background: isActive ? '#E8F1FF' : 'transparent',
    color: isActive ? '#0866FF' : '#1F2937',
    fontWeight: isActive ? '700' : '400',
    fontSize: '14px',
    borderBottom: '1px solid #F4F6FA',
    transition: 'background 0.1s',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  empty: {
    padding: '20px 16px',
    color: '#9CA3AF',
    fontSize: '13px',
  },
};

export default function Sidebar({ isOpen, onClose, sessions = [] }) {
  const navigate = useNavigate();
  const { chatCode: activeChatCode } = useParams();

  const handleSelect = (chatCode) => {
    // Disconnect current WS before navigating — otherwise the old session's
    // stream callbacks fire on the new session's React state
    wsService.disconnect();
    navigate(`/chat/${chatCode}`);
  };

  return (
    <div style={styles.sidebar(isOpen)}>
      <div style={styles.header}>
        <span>Recent Chat Codes</span>
        <button style={styles.closeBtn} onClick={onClose} title="Close">✕</button>
      </div>
      <div style={styles.list}>
        {sessions.length === 0 ? (
          <div style={styles.empty}>No recent sessions</div>
        ) : (
          sessions.map((s) => (
            <div
              key={s.chatCode}
              style={styles.item(String(s.chatCode) === String(activeChatCode))}
              onClick={() => handleSelect(s.chatCode)}
            >
              {s.chatCode} {s.candidateName}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
